import { OptionsLayout } from '../../ui/options-layout';
import { NUMBER_OF_COLUMNS } from '../../ui/options-layout/options-layout-constants';
import { getIsOtherOptionSelected, getOtherLabel, getOtherValue, OTHER_ID } from '../../ui/radio-group-field/radio-group-field-utils';
import React, { useCallback, useRef, useState } from 'react';
import { useTranslation } from '../../contexts/translation-context';
import { ForcedState, useForcedState } from '../../contexts/forced-state-context';
import Fieldset from '../../ui/fieldset';
import classNames from 'classnames';
import { RadioButton as TPARadioButton, TextField as TPATextField, TextFieldTheme } from 'wix-ui-tpa/cssVars';
import styles from '../../ui/radio-group-field/radio-group-field-wut.module.scss';
import { classes } from '../../ui/radio-group-field/radio-group-field-wut.st.css';
import { useFocusFieldEvent } from '../../contexts/events-context';
export const RadioGroupInputWUT = _ref => {
  let {
    target,
    inputId,
    labelId,
    hasError,
    options,
    ariaDescribedBy,
    addOther,
    addOtherLabel,
    addOtherPlaceholder,
    required,
    value,
    onChange,
    onFocus,
    onBlur,
    disabled = false,
    otherInputCharacterLimit,
    numberOfColumns = NUMBER_OF_COLUMNS.ONE,
    fieldId
  } = _ref;
  const isOtherOptionSelected = getIsOtherOptionSelected(options, value);
  const [otherSelected, setOtherSelected] = useState(isOtherOptionSelected);
  const [otherValue, setOtherValue] = useState(isOtherOptionSelected && value ? getOtherValue(value, addOtherLabel) : '');
  const {
    t
  } = useTranslation();
  const firstRadioButtonRef = useRef(null);
  const otherLabel = getOtherLabel(addOtherLabel, t);
  const forcedHover = useForcedState().includes(ForcedState.INPUT_FIELDS_HOVER);
  const handleChange = useCallback(option => {
    onChange(option);
  }, [onChange]);
  useFocusFieldEvent(() => {
    var _firstRadioButtonRef$;
    (_firstRadioButtonRef$ = firstRadioButtonRef.current) == null || _firstRadioButtonRef$.focus({
      preventScroll: true
    });
  }, fieldId);
  const handleOtherChange = event => {
    event.stopPropagation();
    const input = event.target.value;
    let _otherValue;
    if (input) {
      _otherValue = `${addOtherLabel}: ${input}`;
    } else {
      _otherValue = otherLabel;
    }
    handleChange(_otherValue);
    setOtherValue(input);
    setOtherSelected(true);
  };
  return /*#__PURE__*/React.createElement(Fieldset, {
    id: inputId,
    ariaLabelledBy: labelId,
    className: classNames(classes.radioGroup, {
      [classes.error]: hasError
    }),
    ariaDescribedBy: ariaDescribedBy,
    onFocus: onFocus,
    onBlur: onBlur,
    required: required
  }, /*#__PURE__*/React.createElement(OptionsLayout, {
    numberOfColumns: numberOfColumns
  }, options == null ? void 0 : options.map((_ref2, index) => {
    let {
      label: optionLabel,
      value: optionValue
    } = _ref2;
    const valueToSave = optionValue ?? optionLabel;
    return /*#__PURE__*/React.createElement(TPARadioButton, {
      key: `radioButton-${optionLabel}`,
      label: optionLabel,
      checked: valueToSave === value && Boolean(valueToSave),
      value:
      // TODO remove when WSR fixes bug
      valueToSave ? valueToSave : undefined,
      onChange: e => {
        const newValue = String(e.value);
        if (newValue !== value) {
          handleChange(newValue);
          setOtherSelected(false);
          setOtherValue('');
        }
      },
      name: target,
      disabled: disabled,
      className: classNames(classes.radioButton, styles.radioButton, {
        [styles.radioButtonError]: hasError,
        [classes.hover]: forcedHover
      }),
      ref: index === 0 ? firstRadioButtonRef : undefined
    });
  })), addOther && /*#__PURE__*/React.createElement("div", {
    className: classes.otherContainer
  }, /*#__PURE__*/React.createElement(TPARadioButton, {
    key: `radioButton-${addOtherLabel || OTHER_ID}`,
    label: otherLabel,
    checked: otherSelected,
    value: addOtherLabel || OTHER_ID,
    onChange: () => {
      handleChange(`${otherLabel}`);
      setOtherSelected(true);
    },
    disabled: disabled,
    name: target,
    error: hasError,
    className: classNames(classes.radioButton, styles.radioButton, {
      [styles.radioButtonError]: hasError
    })
  }), otherSelected && /*#__PURE__*/React.createElement(TPATextField, {
    className: classNames(classes.otherInput, classes.theme),
    value: otherValue,
    placeholder: addOtherPlaceholder,
    onChange: handleOtherChange,
    disabled: disabled,
    error: hasError,
    theme: TextFieldTheme.Box,
    maxLength: otherInputCharacterLimit,
    showCharCount: Boolean(otherInputCharacterLimit),
    "aria-label": otherLabel
  })));
};
//# sourceMappingURL=radio-group-input-wut.js.map